// src/redux/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for fetching Home data
export const fetchHomepage = createAsyncThunk(
  "content/fetchFeatures",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("https://cms.abrigogroup.com/api/request/home-page");
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(error.response?.data || "An error occurred while fetching Home data");
    }
  }
);

export const fetchObjectpage = createAsyncThunk(
    "content/fetchOjectpage",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get("https://cms.abrigogroup.com/api/request/about-us");
        return response.data;
      } catch (error) {
        console.error("Error fetching about data:", error);
        return rejectWithValue(error.response?.data || "An error occurred while fetching Home data");
      }
    }
  );

  export const fetchGeneralpage = createAsyncThunk(
    "content/fetchGeneralpage",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get("https://cms.abrigogroup.com/api/request/general-settings");
        return response.data;
      } catch (error) {
        console.error("Error fetching about data:", error);
        return rejectWithValue(error.response?.data || "An error occurred while fetching Home data");
      }
    }
  );

  export const fetchContactpage = createAsyncThunk(
    "content/fetchContactpage",
    async (_, { rejectWithValue }) => {
      try {
        const response = await axios.get("https://cms.abrigogroup.com/api/request/contact-us");
        return response.data;
      } catch (error) {
        console.error("Error fetching about data:", error);
        return rejectWithValue(error.response?.data || "An error occurred while fetching Home data");
      }
    }
  );

const homeSlice = createSlice({
  name: "features",
  initialState: {
    homeObject: null,
    contactObject: null,
    aboutObject: null,
    contactloading: false,
    generalObject: null,
    aboutloading: false,
    loading: false,
    error: null,
  },
  reducers: {}, // No synchronous reducers
  extraReducers: (builder) => {
    builder
      // Fetch Home Data
      .addCase(fetchHomepage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomepage.fulfilled, (state, action) => {
        state.loading = false;
        state.homeObject = action.payload;
      })
      .addCase(fetchHomepage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


      builder
      // Fetch Home Data
      .addCase(fetchContactpage.pending, (state) => {
        state.contactloading = true;
        state.error = null;
      })
      .addCase(fetchContactpage.fulfilled, (state, action) => {
        state.contactloading = false;
        state.contactObject = action.payload;
      })
      .addCase(fetchContactpage.rejected, (state, action) => {
        state.contactloading = false;
        state.error = action.payload;
      });

      builder
      // Fetch Home Data
      .addCase(fetchObjectpage.pending, (state) => {
        state.aboutloading = true;
        state.error = null;
      })
      .addCase(fetchObjectpage.fulfilled, (state, action) => {
        state.aboutloading = false;
        state.aboutObject = action.payload;
      })
      .addCase(fetchObjectpage.rejected, (state, action) => {
        state.aboutloading = false;
        state.error = action.payload;
      });

      builder
      // Fetch Home Data
      .addCase(fetchGeneralpage.pending, (state) => {
        state.generalloading = true;
        state.error = null;
      })
      .addCase(fetchGeneralpage.fulfilled, (state, action) => {
        state.generalloading = false;
        state.generalObject = action.payload;
      })
      .addCase(fetchGeneralpage.rejected, (state, action) => {
        state.generalloading = false;
        state.error = action.payload;
      });

  },
});

export default homeSlice.reducer;
